import { render, staticRenderFns } from "./QrPage.vue?vue&type=template&id=32df3c5e&scoped=true"
import script from "./QrPage.vue?vue&type=script&lang=js"
export * from "./QrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df3c5e",
  null
  
)

export default component.exports